<template>
    <v-card-title class="justify-space-between">
        <div>{{ title }}</div>
        <div class="text-right">{{ count }}</div>
    </v-card-title>
</template>

<script>
export default {
    props: {
        title: String,
        count: Number
    }
}
</script>